import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'

import { selectors as UserGroupSelectors } from 'data/userGroups'

import { ThinChevronIcon } from 'components/Utils/Icons'
import UserRow from 'components/Users/UserRow'
import { Text } from 'components/base'

class ShowGroup extends Component {
  render() {
    return (
      <React.Fragment>
        <div
          onClick={() => this.props.goToList()}
          className="pointer flexbox flexbox-align-center"
        >
          <ThinChevronIcon
            size={12}
            className="margin-right-small shade-30"
            style={{ transform: 'rotate(180deg)' }}
          />
          <span className="shade-20">Back to your groups</span>
        </div>
        <Text.Subtitle className="margin-vertical-large">
          {this.props.userGroup.name}
        </Text.Subtitle>
        {this.props.userGroupMembers.map(user => (
          <UserRow className="margin-vertical-large" user={user} />
        ))}
      </React.Fragment>
    )
  }
}

export default compose(
  connect((state, { userGroupId }) => ({
    userGroup: UserGroupSelectors.getUserGroup(state, userGroupId),
    userGroupMembers: UserGroupSelectors.getUserGroupMembers(
      state,
      userGroupId
    ).toArray(),
  }))
)(ShowGroup)
